import { useState } from "react"
import { Link } from 'react-router-dom'
import { PrimaryMenu } from '../menus';
import style from 'src/css/_header.module.scss'
import { Fade } from "react-reveal";

const isValidUrl = url => /^[a-z][a-z0-9+.-]*:/.test(url);

const Header = props => {
    // ** Props
    const { handleBlur, handleFocus, location } = props
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);

    const toggleAside = () => {
        const aside = document.getElementById('aside');
        aside.classList.toggle('active');

        setIsNavOpen(false)
    }

    const handleNav = () => {
        setOpenDropdown(null);
        setIsNavOpen(false);
    }

    return (
        <header className="absolute py-5 z-50 w-full h-[72px] max-w-[1920px] left-1/2 -translate-x-2/4" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
            <div className="__header-wrapper flex justify-between sm:px-16 items-center">
                <div className="brand sm:px-0 px-[1rem] flex items-center">
                    <Link to="/" aria-label="Home">
                        <img src="/image/JL-RABELAS-logo.svg" width={150} alt="" className="max-w-full" />
                    </Link>
                </div>
                <nav className="__navigation lg:w-[68%] lg:block flex items-center gap-2">
                    {/* desktop nav */}
                    <div className="flex justify-between gap-6">
                        <ul className={`hidden lg:flex ${style.menu}`}>
                            {PrimaryMenu.map((item) => (
                                <li
                                    key={item.label}
                                    className={`${style.menuItem} ${item.children ? style.dropdown : ''}`}
                                    onMouseEnter={() => item.children && setOpenDropdown(item.label)}
                                    onMouseLeave={() => setOpenDropdown(null)}
                                >
                                    {item.children ? (
                                        <>
                                            <span aria-label={item.label}>{item.label}<span className={style.arrow}>&#9660;</span></span>
                                            <ul className={`${style.dropdownMenu} ${openDropdown === item.label ? style.open : ''}`}>
                                                {item.children.map(child => (
                                                    <li key={child.label}>
                                                        {isValidUrl(child.path) ? (
                                                            <a
                                                                href={child.path}
                                                                aria-labelledby={`Open ${child.label} page`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                onClick={handleNav}
                                                            >
                                                                {child.label}
                                                            </a>
                                                        ) : (
                                                            <Link
                                                                to={child.path}
                                                                aria-labelledby={`Open ${child.label} page`}
                                                                onClick={handleNav}
                                                            >
                                                                {child.label}
                                                            </Link>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    ) : (
                                        isValidUrl(item.path) ? (
                                            <a
                                                href={item.path}
                                                aria-labelledby={`Open ${item.label} page`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={handleNav}
                                            >
                                                {item.label}
                                            </a>
                                        ) : (
                                            <Link
                                                to={item.path}
                                                aria-labelledby={`Open ${item.label} page`}
                                                onClick={handleNav}
                                            >
                                                {item.label}
                                            </Link>
                                        )
                                    )}
                                </li>
                            ))}
                        </ul>
                        <button className={`${style.getInTouchBtn} items-center gap-4 hidden lg:flex`} onClick={toggleAside}>
                            Connect
                            <img src="/image/right_arrow.svg" width={20} alt="" className="max-w-full" />
                        </button>
                    </div>
                    {/* mobile nav */}
                    <section className="flex lg:hidden sm:mx-0 mx-5">
                        {/* hamburger menu */}
                        <div
                            className="space-y-2"
                            onClick={() => setIsNavOpen((prev) => !prev)}
                        >
                            <span className="block h-0.5 w-8 animate-pulse bg-[#ffffff]"></span>
                            <span className="block h-0.5 w-8 animate-pulse bg-[#ffffff]"></span>
                            <span className="block h-0.5 w-8 animate-pulse bg-[#ffffff]"></span>
                        </div>

                        <div className={isNavOpen ? "showMenuNav transition ease-in-out delay-150" : "hideMenuNav"}>
                            <Fade duration={500} >
                                {/* cross icon */}
                                <div
                                    className="absolute top-0 right-0 px-8 py-8"
                                    onClick={() => setIsNavOpen((prev) => !prev)}
                                >
                                    <svg
                                        className="h-8 w-8 text-gray-600"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="white"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <line x1="18" y1="6" x2="6" y2="18" />
                                        <line x1="6" y1="6" x2="18" y2="18" />
                                    </svg>
                                </div>
                                <ul className="MENU-LINK-MOBILE-OPEN flex flex-col items-center justify-between min-h-[250px]">
                                    {PrimaryMenu.map((item) => (
                                        <li className="border-b border-gray-400 my-5 text-center" key={item.label}>
                                            {item.children ? (
                                                <>
                                                    <span className="text-white block text-center font-bold uppercase tracking-wide mb-2">{item.label}</span>
                                                    <ul className="pl-4 text-left">
                                                        {item.children.map(child => (
                                                            <li className="my-2" key={child.label}>
                                                                {isValidUrl(child.path) ? (
                                                                    <a
                                                                        className="text-white underline"
                                                                        href={child.path}
                                                                        aria-labelledby={`Open ${child.label} page`}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        onClick={() => setIsNavOpen(false)}
                                                                    >
                                                                        {child.label}
                                                                    </a>
                                                                ) : (
                                                                    <Link
                                                                        className="text-white underline"
                                                                        to={child.path}
                                                                        aria-labelledby={`Open ${child.label} page`}
                                                                        onClick={() => setIsNavOpen(false)}
                                                                    >
                                                                        {child.label}
                                                                    </Link>
                                                                )}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </>
                                            ) : (
                                                isValidUrl(item.path) ? (
                                                    <a
                                                        className="text-white underline"
                                                        href={item.path}
                                                        aria-labelledby={`Open ${item.label} page`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        onClick={() => setIsNavOpen(false)}
                                                    >
                                                        {item.label}
                                                    </a>
                                                ) : (
                                                    <Link
                                                        className="text-white underline"
                                                        to={item.path}
                                                        aria-labelledby={`Open ${item.label} page`}
                                                        onClick={() => setIsNavOpen(false)}
                                                    >
                                                        {item.label}
                                                    </Link>
                                                )
                                            )}
                                        </li>
                                    ))}
                                </ul>
                                <button className={`text-white flex items-center gap-4 lg:hidden mt-4`} onClick={toggleAside}>
                                    Connect
                                </button>
                            </Fade>
                        </div>
                    </section>
                </nav>
            </div>
        </header>
    );
}

export default Header;
